import { Component, inject, Input, NgZone, OnInit } from '@angular/core';
import { doughnutChartTransformer, TransformChartOptionsPipe } from '@utils/charts';
import { HighchartsDirective, HighchartsSizeStrategy } from '@utils/charts/highcharts.directive';
import { CustomEvents } from '@utils/events/custom-events';
import { EventContext } from '@utils/events/event-context';
import { Renderable } from 'src/openapi-client/model/renderable';

@Component({
  selector: 'wct-doughnut-chart',
  standalone: true,
  imports: [HighchartsDirective, TransformChartOptionsPipe],
  templateUrl: './doughnut-chart.component.html',
  styleUrl: './doughnut-chart.component.scss'
})
export class DoughnutChartComponent implements OnInit {
  @Input({ required: true }) public data: Highcharts.Options | Renderable;
  @Input({ required: false }) public sum: string | number | undefined;
  @Input({ required: false }) public set names(names: Renderable | undefined) {
    this.mapNames(names);
  }
  @Input({ required: false }) sizeStrategy?: HighchartsSizeStrategy | undefined = HighchartsSizeStrategy.FIT_CONTAINER;

  protected doughnutChartTransformer: (options: Highcharts.Options) => Highcharts.Options;

  private _names: Map<string, string>;
  private _namesRenderable: unknown;

  private readonly zone: NgZone = inject(NgZone);
  private readonly eventContext: EventContext = inject(EventContext);

  ngOnInit(): void {
    this.doughnutChartTransformer = doughnutChartTransformer(this.handleClick, this._names, 'Gesamtbestand', this.sum);
  }

  protected readonly handleClick = (key: string): void => {
    this.zone.run(() => this.eventContext.dispatch(CustomEvents.TreeMapClick, key));
  }

  private mapNames(table?: Renderable): void {
    if (table === this._namesRenderable) {
      return;
    }

    this._namesRenderable = table;

    if (!table) {
      return;
    }

    const names: Map<string, string> = new Map();

    for (const row of table.rows) {
      if (row.head) {
        continue;
      }

      const key: string = row.cells[0].content;
      const value: string = row.cells[1].content;

      names.set(key, value);
    }

    this._names = names;
  }
}
